import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { isRequiredOnceNoteDated } from '../../../../SetupAndBorrower/Setup/functions/isRequiredOnceNoteDated';
import { toPositiveNumber } from './functions/toPositiveNumber';

interface ApprovedLoanAmountFieldProps {
    /**
     * Bridge loans enter it by hand, so it's only locked while "Same as Committed". Other loans lock it when there's
     * more than one property (the amount comes from the properties; see PropertySlice.properties' TODO).
     */
    isBridgeLoan?: boolean;
}

/** "Apprvd Loan Amt" (the loan's commitment). */
export const ApprovedLoanAmountField = ({ isBridgeLoan = false }: ApprovedLoanAmountFieldProps) => {
    const value = useStandardLoanStore((state) => state.loan.commitment);
    const sameAsCommitted = useStandardLoanStore((state) => state.sameAsCommitted);
    const setup = useStandardLoanStore((state) => state.setup);
    const propertyCount = useStandardLoanStore((state) => state.properties.length);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanCommitment'
            value={value}
            onChange={(amount) => updateLoan({ commitment: toPositiveNumber(amount) })}
            label='Apprvd Loan Amt'
            required={isRequiredOnceNoteDated(setup)}
            disabled={isBridgeLoan ? sameAsCommitted : propertyCount > 1}
            displayChange={true}
            showInfoIcon={true}
            infoText={
                <>
                    Approved Amount of the Loan.
                    <br />
                    <br />
                    This amount does not include the Origination Fee.
                </>
            }
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
